const EVENT_THROTTLE_MS = 15000;

function getLastSentKey(eventName) {
  return `audit_event_${eventName}_last_sent`;
}

function shouldThrottle(eventName) {
  const lastSent = parseInt(localStorage.getItem(getLastSentKey(eventName)) || '0', 10);
  return Date.now() - lastSent < EVENT_THROTTLE_MS;
}

function markSent(eventName) {
  localStorage.setItem(getLastSentKey(eventName), String(Date.now()));
}

function getRequestId() {
  return localStorage.getItem('last_request_id') || null;
}

export async function sendAuditEvent({ eventName, outcome, pageRoute }) {
  if (!eventName || !outcome) return;
  if (shouldThrottle(eventName)) return;

  const anonymousSessionId = localStorage.getItem('anonymous_session_id') || null;
  const payload = {
    event_name: eventName,
    outcome,
    page_route: pageRoute || window.location.pathname,
    anonymous_session_id: anonymousSessionId,
    request_id: getRequestId()
  };

  try {
    const token = localStorage.getItem('access_token');
    await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/audit/client`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify(payload)
    });
    markSent(eventName);
  } catch (err) {
    // Swallow client telemetry failures to avoid impacting UX.
  }
}

export function ensureAnonymousSession() {
  if (!localStorage.getItem('anonymous_session_id')) {
    localStorage.setItem('anonymous_session_id', crypto.randomUUID());
  }
}
